<template>
	<a class="item" :class="{active}" @click="select">
		{{label}}
		<span class="icon" v-if="active" v-html="require('@/assets/icons/check.svg')"></span>
	</a>
</template>

<script>

export default {
	props: {
		selectValue: {type: Array, required: true},
		value: {type: Number, required: true},
		label: {type: String, required: true}
	},
	computed: {
		active() {
			return this.selectValue.includes(this.value);
		}
	},
	methods: {
		select() {
			this.$emit("select", {value: this.value});
		}
	}
};
</script>

<style lang="scss" scoped>
.item {
	display: flex;
	justify-content: space-between;
	padding: 1em;
	font-size: 14px;
	transition: background-color .15s ease-in-out;
	
	&.active {
		color: $petroleum1;
		font-weight: bold;
	}

	&:hover{
		background-color: $grey2;
	}
	@include res(mobile) {
		margin: 0 1em;
		padding: 0.8em 0;
	}
	.icon {
		margin-left: 10px;
		flex-shrink: 0;
		/deep/ svg {
			vertical-align: middle;
			width: 1em;
			height: 1em;
			path {
				fill: $petroleum1
			}
		}
	}
}
</style>
